// import React, { useEffect, useState } from "react";
// import { LayersControl, MapContainer, TileLayer, useMap } from "react-leaflet";
// import L from "leaflet";

// const HCLMap = ({ farmerGeojson }) => {
//   const [geoJsonData, setGeojsonData] = useState([]);
//   useEffect(() => {
//     setGeojsonData(farmerGeojson);
//   }, [farmerGeojson]);

//   const MapController = ({ geoJsonData }) => {
//     console.log("geoJsonData",geoJsonData)
//     const map = useMap();
//     useEffect(() => {
//       if (!geoJsonData?.features?.length > 0) return;
//       map.addLayer(L.geoJSON(geoJsonData));
//       map.fitBounds(L.geoJSON(geoJsonData).getBounds());
//     }, [geoJsonData, map]);

//     return null;
//   };

//   return (
//     <MapContainer
//       center={[25.5811501, 81.9701028]}
//       zoom={13}
//       style={{ width: "100%", height: "100%" }}
//     >
//       <MapController geoJsonData={geoJsonData} />
//       <LayersControl position="topright"></LayersControl>
//       <TileLayer url="http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}" />
//     </MapContainer>
//   );
// };

// export default HCLMap;

// import React, { useEffect, useState } from "react";
// import { LayersControl, MapContainer, TileLayer, useMap } from "react-leaflet";
// import L from "leaflet";
// import {  useNavigate } from "react-router-dom";

// const HCLMap = ({ farmerGeojson }) => {
//   const [geoJsonData, setGeojsonData] = useState([]);
//     const navigate = useNavigate();

//   useEffect(() => {
//     setGeojsonData(farmerGeojson);
//   }, [farmerGeojson]);

//   const MapController = ({ geoJsonData }) => {
//     const map = useMap();

//     useEffect(() => {
//       if (!geoJsonData?.features?.length) return;

//       const getColor = (ACS) => {
//         if (ACS < 50) return "red";
//         if (ACS >= 50 && ACS <= 75) return "yellow";
//         return "green";
//       };

//       const geoJsonLayer = L.geoJSON(geoJsonData, {
//         style: (feature) => ({
//           color: getColor(feature.properties.ACS),
//           weight: 2,
//           fillOpacity: 0.5,
//         }),

//         onEachFeature: function(feature, layer) {
//           const Wrapperdiv = document.createElement("div");
//           Wrapperdiv.className = "farmer-info-wrapper";

//           Wrapperdiv.innerHTML = `<div className="farmerName">
//         <div>
//         <b >Farmer Name </b>: ${feature.properties.farmer_name}
//          </div><br/>
//          <div>
//          <b> Mobile Number  </b>:<span> ${feature.properties.phone_number}</span>
//           </div><br/>

//         <div>
//         <b> State  </b>: ${feature.properties.state_name}
//          </div><br/>
//          <div>
//          <b> District </b> : ${feature.properties.district_name}
//           </div><br/>
//           <div>
//             <b> Land Mark  </b>: ${feature.properties.land_mark}
//              </div><br/>
//             <b class=""> ACS  </b>: ${feature.properties.ACS}
//           </div><br/>
//          <div>`;

//           const button = document.createElement("button");
//           button.innerHTML = "View Details";
//           button.style.cssText +=
//             "color:white;background-color:green;padding:7px;border:1px solid transparent;width:100%";

//           button.onclick = function() {
//             navigate(`/hcl-dashboard/onboarding/${feature.properties.id}`, {
//               state: {
//                 fullname: feature.row.full_name,
//               },
//             })
//                  };

//           Wrapperdiv.appendChild(button);
//           return layer.bindPopup(Wrapperdiv);
//         },
//       });

//       geoJsonLayer.addTo(map);

//       // Ensure valid bounds before calling fitBounds
//       const bounds = geoJsonLayer.getBounds();
//       if (bounds.isValid()) {
//         map.fitBounds(bounds, { padding: [50, 50] });
//       }

//       return () => {
//         map.removeLayer(geoJsonLayer);
//       };
//     }, [geoJsonData, map]);

//     return null;
//   };

//   return (
//     <MapContainer center={[25.5811501, 81.9701028]} zoom={13} style={{ width: "100%", height: "100%" }}>
//       <LayersControl position="topright">
//         <LayersControl.BaseLayer checked name="Satellite View">
//           <TileLayer url="http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}" />
//         </LayersControl.BaseLayer>
//         <LayersControl.BaseLayer name="Street Map">
//           <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
//         </LayersControl.BaseLayer>
//       </LayersControl>
//       <MapController geoJsonData={geoJsonData} />
//     </MapContainer>
//   );
// };

// export default HCLMap;
import * as L from "leaflet";
import "leaflet.markercluster";
import "leaflet/dist/leaflet.css";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

var myIcon = L.icon({
  iconUrl: require("./marker4.jpg"),
  iconSize: [24, 35],
  iconAnchor: [12, 35],
  popupAnchor: [0, -30],
});

const getColor = (ACS) => {
  if(ACS===null) return "blue";
  if (ACS < 50) return "red";
  if (ACS >= 50 && ACS <= 60) return "yellow";
  return "green";
};

const HCLMap = (props) => {
  const navigate = useNavigate();
  const [geoJson, setGeoJson] = useState();
  const [geoJson2, setGeoJson2] = useState(null);

  useEffect(() => {
    fetch(
      "https://lc-research-projects.s3.ap-south-1.amazonaws.com/maati/prayagraj_block_boundaries.geojson"
    ).then((resp) => {
      resp.json().then((geoJsonData) => {
        setGeoJson2(geoJsonData);
      });
    });
  }, []);

  useEffect(() => {
    if (props.showGeojson) {
      setGeoJson(props.showGeojson);
    }
  }, [props]);

  

  // useEffect(() => {
  //   const map = L.map("mapId", {
  //     center: [28.6591285, 77.3165729],
  //     zoom: 6,
  //   });

  //   const googleSatellite = L.tileLayer(
  //     "http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}",
  //     { maxZoom: 22, attribution: "© Google Maps" }
  //   ).addTo(map); // Default base layer

  //   const streetLayer = L.tileLayer(
  //     "http://mt0.google.com/vt/lyrs=m&hl=en&x={x}&y={y}&z={z}",
  //     { maxZoom: 22, attribution: "© Google" }
  //   );

  //   const cropMask = L.tileLayer(
  //     "https://z0c3v6ezdg.execute-api.ap-south-1.amazonaws.com/cog/tiles/WebMercatorQuad/{z}/{x}/{y}@1x?url=https%3A%2F%2Flc-research-projects.s3.ap-south-1.amazonaws.com%2Fmaati%2Fprayagraj_v1_crop_mask_v3.tif&colormap=%7B%221%22%3A+%22%2338761D%22%2C+%222%22%3A+%22%23B7E1CD%22%7D",
  //     { tms: false, maxZoom: 22 }
  //   ).addTo(map); 

  //   const boundaryLayer = L.geoJSON(geoJson2, {
  //     style: { fillOpacity: 0, color: "red", weight: 1 },
  //     onEachFeature: (feature, layer) => {
  //       if (!layer) return;
  //       layer.on({
  //         click: () => {
  //           map.fitBounds(L.geoJSON(feature).getBounds());
  //         },
  //       });
  //     },
  //   }).addTo(map); 

  //   var markersBar = L.markerClusterGroup();
  //   var barLayer = new L.geoJson(geoJson, {
  //     style: (feature) => ({
  //       color: getColor(feature.properties.ACS),
  //       weight: 2,
  //       fillOpacity: 0.5,
  //     }),
  //     pointToLayer: function(feature, latlng) {
  //       return L.marker(latlng, { icon: myIcon });
  //     },
  //     onEachFeature: function(feature, layer) {
  //       const Wrapperdiv = document.createElement("div");
  //       Wrapperdiv.className = "farmer-info-wrapper";

  //       Wrapperdiv.innerHTML = `<div className="farmerName"> 
  //           <div><b>Farmer Name </b>: ${feature.properties.farmer_name}</div><br/>
  //           <div><b> Mobile Number </b>:<span> ${feature.properties.phone_number}</span></div><br/>
  //           <div><b> State </b>: ${feature.properties.state_name}</div><br/>
  //           <div><b> District </b>: ${feature.properties.district_name}</div><br/>
  //           <div><b> Land Mark </b>: ${feature.properties.land_mark}</div><br/>
  //           <b> Farm Score  </b>: ${feature.properties.ACS} 
  //         </div>`;

  //       const button = document.createElement("button");
  //       button.innerHTML = "View Details";
  //       button.style.cssText =
  //         "color:white;background-color:green;padding:7px;border:1px solid transparent;width:100%";
  //       button.onclick = function() {
  //         navigate(
  //           `/hcl-dashboard/onboarding/${feature.properties.farmer_id}`,
  //           {
  //             state: { fullname: "" },
  //           }
  //         );
  //       };

  //       layer.on({
  //         click: () => {
  //           map.fitBounds(L.geoJSON(feature).getBounds());
  //         },
  //       });

  //       Wrapperdiv.appendChild(button);
  //       return layer.bindPopup(Wrapperdiv);
  //     },
  //   });

  //   markersBar
  //     .addLayer(barLayer)
  //     .addTo(map)
  //     .bringToFront();

  //   const baseLayers = {
  //     "Google Satellite": googleSatellite,
  //     "Google Street View": streetLayer,
  //   };

  //   const overlayLayers = {
  //     ...(props?.RoleAcessParams.includes("HCL") && { "Crop Mask": cropMask }),
  //     ...(props?.RoleAcessParams.includes("HCL") && { Boundary: boundaryLayer }),
  //     Plots: markersBar,
  //   };
    

  //   L.control
  //     .layers(baseLayers, overlayLayers, { collapsed: false })
  //     .addTo(map);

  //   if (geoJson2) {
  //     map.fitBounds(L.geoJson(geoJson2).getBounds());
  //   }

  //   return () => {
  //     map.off();
  //     map.remove();
  //   };
  // }, [geoJson, geoJson2, navigate]);




  useEffect(() => {
    const map = L.map("mapId", {
      center: [28.6591285, 77.3165729],
      zoom: 6,
    });
  
    const googleSatellite = L.tileLayer(
      "http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}",
      { maxZoom: 22, attribution: "© Google Maps" }
    ).addTo(map); // Default base layer
  
    const streetLayer = L.tileLayer(
      "http://mt0.google.com/vt/lyrs=m&hl=en&x={x}&y={y}&z={z}",
      { maxZoom: 22, attribution: "© Google" }
    );
  
    let cropMask;
    let boundaryLayer;
  
    if (props?.RoleAcessParams.includes("HCL")) {
      cropMask = L.tileLayer(
        "https://z0c3v6ezdg.execute-api.ap-south-1.amazonaws.com/cog/tiles/WebMercatorQuad/{z}/{x}/{y}@1x?url=https%3A%2F%2Flc-research-projects.s3.ap-south-1.amazonaws.com%2Fmaati%2Fprayagraj_v1_crop_mask_v3.tif&colormap=%7B%221%22%3A+%22%2338761D%22%2C+%222%22%3A+%22%23B7E1CD%22%7D",
        { tms: false, maxZoom: 22 }
      ).addTo(map);
  
      boundaryLayer = L.geoJSON(geoJson2, {
        style: { fillOpacity: 0, color: "red", weight: 1 },
        onEachFeature: (feature, layer) => {
          if (!layer) return;
          layer.on({
            click: () => {
              map.fitBounds(L.geoJSON(feature).getBounds());
            },
          });
        },
      }).addTo(map);
    }
  
    var markersBar = L.markerClusterGroup();
    var barLayer = new L.geoJson(geoJson, {
      style: (feature) => ({
        color: getColor(feature.properties.ACS),
        weight: 2,
        fillOpacity: 0.5,
      }),
      pointToLayer: function (feature, latlng) {
        return L.marker(latlng, { icon: myIcon });
      },
      onEachFeature: function (feature, layer) {
        const Wrapperdiv = document.createElement("div");
        Wrapperdiv.className = "farmer-info-wrapper";
  
        Wrapperdiv.innerHTML = `<div className="farmerName"> 
            <div><b>Farmer Name </b>: ${feature.properties.farmer_name}</div><br/>
            <div><b> Mobile Number </b>:<span> ${feature.properties.phone_number}</span></div><br/>
            <div><b> State </b>: ${feature.properties.state_name}</div><br/>
            <div><b> District </b>: ${feature.properties.district_name}</div><br/>
            <div><b> Land Mark </b>: ${feature.properties.land_mark}</div><br/>
            <b> Farm Score  </b>: ${feature.properties.ACS===null?0:feature.properties.ACS}
          </div>`;
  
        const button = document.createElement("button");
        button.innerHTML = "View Details";
        button.style.cssText =
          "color:white;background-color:green;padding:7px;border:1px solid transparent;width:100%";
        button.onclick = function () {
          {props?.newAdminHcl? navigate(
            `/farmerDetails/onboarding/${feature.properties.farmer_id}`,
            {
              state: { fullname: "" },
            }
          ):
          navigate(
            `/farmerDetail/onboarding/${feature.properties.farmer_id}`,
            {
              state: { fullname: "" },
            }
          );
        }
        };
  
        layer.on({
          click: () => {
            map.fitBounds(L.geoJSON(feature).getBounds());
          },
        });
  
        Wrapperdiv.appendChild(button);
        return layer.bindPopup(Wrapperdiv);
      },
    });
  
    markersBar.addLayer(barLayer).addTo(map).bringToFront();
  
    const baseLayers = {
      "Google Satellite": googleSatellite,
      "Google Street View": streetLayer,
    };
  
    const overlayLayers = {
      ...(props?.RoleAcessParams.includes("HCL") && { "Crop Mask": cropMask }),
      ...(props?.RoleAcessParams.includes("HCL") && { Boundary: boundaryLayer }),
      Plots: markersBar,
    };
  
    L.control.layers(baseLayers, overlayLayers, { collapsed: false }).addTo(map);
  
    if (props?.RoleAcessParams.includes("HCL") && geoJson2) {
      map.fitBounds(L.geoJson(geoJson2).getBounds());
    }
    else if (geoJson && geoJson.features?.length) {
      map.fitBounds(L.geoJSON(geoJson).getBounds());
    }
     const legend = L.control({ position: "bottomright" });
        
            legend.onAdd = function (map) {
              const div = L.DomUtil.create("div", "info legend custom-legend");
              const grades = ["High", "Moderate", "Low"];
        
        
              const colors = ["green", "yellow", "red"];
            
              let labels = ["<h6 style='margin-bottom: 10px;'>Farm Score</h6>"];
              for (let i = 0; i < grades.length; i++) {
                labels.push(
                  `<div style="display: flex; align-items: center; margin-bottom: 8px;">
                    <i style="background:${colors[i]}; width:18px; height:18px; display:inline-block; margin-right:8px; border:1px solid #000;"></i> 
                    <span style="font-size:14px;">${grades[i]}</span>
                  </div>`
                );
              }
              div.innerHTML = labels.join("");
              return div;
            };
            
            legend.addTo(map);
  
    return () => {
      map.off();
      map.remove();
    };
  }, [geoJson, geoJson2, navigate]);
  

  return (
    <div
      style={{
        padding: 0,
        margin: 0,
        width: "100%",
        height: "100%",
        zIndex: 0,
      }}
      id="mapId"
      className="farmer_map"
    ></div>
  );
};

export default HCLMap;
